import { captureException } from '@sentry/react'
import { type UseQueryOptions, useQuery } from '@tanstack/react-query'
import { z } from 'zod'
import {
	type HttpGetServiceFlags,
	httpGetServiceFlags
} from '@/features/service-vetting/http/services-vetting.http.ts'
import { ServiceFlag } from '@/features/service-vetting/types.ts'
import { parseAxiosPromise } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useGetServiceFlags = (
	params: HttpGetServiceFlags['params'],
	options?: UseQueryOptions<ServiceFlag[]>
) => {
	return useQuery({
		queryKey: [QUERY_KEYS.SERVICE_FLAGS, params],
		queryFn: () =>
			parseAxiosPromise({
				axiosPromise: httpGetServiceFlags({
					params
				}),
				responseShape: z.array(ServiceFlag),
				onZodError: captureException
			}),
		...options
	})
}
